import axios from 'axios'
import { BASE_URL } from '../../constants/config'

async function login(email, password) {
    const options = {
        method: 'post',
        url: `${BASE_URL}/admin/user/login`,
        data: {
            email,
            password
        }
    }
    return axios(options)
}

async function listMembers(search, skip, token) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            search,
            limit: 10,
            skip
        },
        url: `${BASE_URL}/admin/user`
    }
    return axios(options)
}

async function getMember(token, userId) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/admin/user/${userId}`,
    }
    return axios(options)
}


export default {
    login,
    listMembers,
    getMember
}